import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '../utils/utils';

@Pipe({
	name: 'safeDate',
	standalone: true,
	pure: true,
})
export class SafeDatePipe implements PipeTransform {
	transform(value: string | Date | null | undefined, format?: string): string {
		return formatDate(value, format ?? 'dd/MM/yyyy - HH:mm');
	}
}
